export const catalog = {
  catalogSearchInputPlaceholderTitle: 'Пошук',
  catalogHeaderTitle: 'Деталі',
  catalogDetailsCurtainCopyOptionTitle: 'Скопіювати посилання',
  catalogDetailsLinkCopiedAlertText: 'Посилання скопійовано!',
  catalogDetailsCurtainFlagOptionTitle: 'Поскаржитись',
  catalogDetailsFlagCurtainTitle: 'Поскаржитись',
  catalogReportedCurtainContent: 'Скаргу надіслано',
  catalogWantBuy: 'Хочу купити {item} з {app}',
  catalogInterestedIn: '{link}'
}
